interface MetabaseEmbedProps {
  url: string
}

function MetabaseEmbed({ url }: MetabaseEmbedProps) {
  return (
    <iframe
      className="dashboard-embed"
      src={url}
      title="Dashboard"
      allowFullScreen
    />
  )
}

export default MetabaseEmbed
